<script lang="ts">
    import type {RichRecord} from '../../../../typings/portaro.be.types';
    import type {Injector, LocalizeFunction} from '../../../../svelte/types';
    import {getContext, onDestroy} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../../../../svelte/utils';
    import {KpRecordClipboardButtonPresenter} from './kp-record-clipboard-button.presenter';

    export let record: RichRecord;

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpRecordClipboardButtonPresenter = injector.getByToken(KpRecordClipboardButtonPresenter.presenterName);

    let showAddButton = false;
    let showRemoveButton = false;

    const recordsSubscription = presenter.getRecords$().subscribe(() => {
       showAddButton = presenter.canAddToClipboard(record);
       showRemoveButton = presenter.canRemoveToClipboard(record);
    });
    onDestroy(() => recordsSubscription.unsubscribe());

    function add() {
        presenter.addRecord(record);
    }

    function remove() {
        presenter.removeRecord(record);
    }

</script>

<template>

    {#if showAddButton}
        <button type="button"
                class="btn btn-default btn-xs btn-block add-to-clipboard-button"
                on:click={add}>
            <span class="glyphicon glyphicon-ok"></span> {localize(/* @kp-localization commons.Mark */ 'commons.Mark')}
        </button>
    {/if}

    {#if showRemoveButton}
        <button type="button"
                class="btn btn-default btn-xs btn-block remove-from-clipboard-button"
                on:click={remove}>
            <span class="glyphicon glyphicon-ok"></span> {localize(/* @kp-localization commons.Marked */ 'commons.Marked')}
        </button>
    {/if}

</template>

<style lang="less">
  .remove-from-clipboard-button {
    visibility: visible; /* tlacitko odebrat je viditelne porad (ne jen kdyz se najede na nejaky jeho kontejner) */
  }
</style>